import { render } from "./user-toolbar-m1.html?vue&type=template&id=fdf96e5c"
import script from "./UserToolbar.vue?vue&type=script&lang=ts"
export * from "./UserToolbar.vue?vue&type=script&lang=ts"

import "./user-toolbar.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script